import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "my-3" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "my-3" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReadingQuestion = _resolveComponent("ReadingQuestion")!
  const _component_WritingQuestion = _resolveComponent("WritingQuestion")!
  const _component_ReadingAnswer = _resolveComponent("ReadingAnswer")!
  const _component_WritingAnswer = _resolveComponent("WritingAnswer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.noQuestionsMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.noQuestionsMessage), 1))
      : (_ctx.questionPool.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('practice.remaining', {remaining: _ctx.questionPool.length})), 1))
        : _createCommentVNode("", true),
    _hoisted_3,
    (_ctx.getQuestionLoading)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: require('@/assets/loader.gif'),
          width: "50",
          height: "50"
        }, null, 8, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getQuestion && _ctx.getQuestion(...args)))
          }, "⟳"),
          (_ctx.currQuestion)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.questionPool[0].type === 'reading')
                  ? (_openBlock(), _createBlock(_component_ReadingQuestion, {
                      key: 0,
                      question: _ctx.currQuestion,
                      answerLoading: _ctx.submitAnswerLoading,
                      answered: _ctx.currAnswer !== null,
                      onAnswer: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitAnswer($event)))
                    }, null, 8, ["question", "answerLoading", "answered"]))
                  : (_ctx.questionPool[0].type === 'writing')
                    ? (_openBlock(), _createBlock(_component_WritingQuestion, {
                        key: 1,
                        question: _ctx.currQuestion,
                        answerLoading: _ctx.submitAnswerLoading,
                        answered: _ctx.currAnswer !== null,
                        onAnswer: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitAnswer($event)))
                      }, null, 8, ["question", "answerLoading", "answered"]))
                    : _createCommentVNode("", true),
                (_ctx.currAnswer)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.questionPool[0].type === 'reading')
                        ? (_openBlock(), _createBlock(_component_ReadingAnswer, {
                            key: 0,
                            question: _ctx.currQuestion,
                            answer: _ctx.currAnswer
                          }, null, 8, ["question", "answer"]))
                        : _createCommentVNode("", true),
                      (_ctx.questionPool[0].type === 'writing')
                        ? (_openBlock(), _createBlock(_component_WritingAnswer, {
                            key: 1,
                            question: _ctx.currQuestion,
                            answer: _ctx.currAnswer
                          }, null, 8, ["question", "answer"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveExample && _ctx.saveExample(...args))),
                          disabled: _ctx.saveExampleLoading || _ctx.saveExampleDisabled
                        }, _toDisplayString(_ctx.$t('practice.saveExample')), 9, _hoisted_6)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextQuestion && _ctx.nextQuestion(...args)))
                        }, [
                          (_ctx.questionPool.length > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('practice.next')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('practice.practiceAgain')), 1))
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}